import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class PainData{
    static attributePrefix = "Pain";
    static attributePrefixDe = "Schmerzen";
}